import axios from 'axios'
import { Message } from 'element-ui'

const request = axios.create({
    baseURL: '',
    timeout: 10000
})

request.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
  }
  return config
})

request.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code !== 200) {
            Message.error(res.message || '错误')
            return Promise.reject(new Error(res.message || 'Error'))
        }
        return res.data
    },
    error => {
        Message.error(error.message || '网络错误')
        return Promise.reject(error)
    }
)

export default request